// extracted by mini-css-extract-plugin
export var aircallIframe = "_gx-3";
export var fabContainer = "_gx-5";
export var fabRinging = "_gx-6";
export var loadingOverlay = "_gx-4";
export var pulse = "_gx-7";
export var widgetContent = "_gx-2";
export var widgetPanel = "_gx-0";
export var widgetPanelExpanded = "_gx-1";